import React from 'react';

function ProgressIndicator({ step, guestCount, onStepClick }) {
  const steps = [
    { label: 'Location', num: 1, active: step >= 1, done: step > 1, editStep: 1 },
    { label: 'Guests', num: 2, active: step >= 2, done: step > 3 || (step >= 3.5 && guestCount === 1), editStep: 2 },
    { label: 'Services', num: 3, active: step >= 3.5, done: step > 8.5, editStep: 3.5 },
    { label: 'Time', num: 4, active: step >= 9, done: step > 9, editStep: 9 },
    { label: 'Confirm', num: 5, active: step >= 9.5, done: false, editStep: 9.5 },
  ];

  return (
    <div className="progress-indicator">
      {steps.map((s, i, arr) => (
        <React.Fragment key={s.num}>
          <div className={`progress-step ${s.active ? 'active' : ''} ${s.done ? 'completed' : ''}`}>
            {s.done ? (
              <button
                type="button"
                className="progress-circle progress-circle--tappable"
                onClick={() => onStepClick(s.editStep)}
                aria-label={`Edit ${s.label}`}
              >
                ✓
              </button>
            ) : (
              <div className="progress-circle">{s.num}</div>
            )}
            <div className="progress-label">{s.label}</div>
          </div>
          {i < arr.length - 1 && <div className={`progress-line ${s.done ? 'completed' : ''}`}></div>}
        </React.Fragment>
      ))}
    </div>
  );
}

export default ProgressIndicator;
